// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__NnS26","blurred":"styles_blurred__jXfXe"};